module.exports = __webpack_public_path__ + "img/unstarted.c1483c16.svg";